import { useEffect, useRef, useState } from "react";
import HALogo from "@/components/HALogo";

export default function AgeGate() {
  const [visible, setVisible] = useState(false);
  const yesRef = useRef(null);

  useEffect(() => {
    if (!localStorage.getItem("hat_age_verified")) setVisible(true);
  }, []);

  useEffect(() => {
    if (visible && yesRef.current) yesRef.current.focus();
  }, [visible]);

  if (!visible) return null;

  const confirm = () => {
    localStorage.setItem("hat_age_verified", "1");
    setVisible(false);
  };
  const decline = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-5 bg-navy/85 backdrop-blur-xl"
      data-testid="age-gate-overlay"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="age-gate-title"
        data-testid="age-gate-modal"
        className="relative w-full max-w-md text-center bg-navy/95 border border-copper/40 px-9 py-11 shadow-2xl"
        style={{ animation: "ranchCardIn 0.5s cubic-bezier(0.16,1,0.3,1) both" }}
      >
        <HALogo className="h-12 w-auto mx-auto" />
        <div className="mt-3 text-[11px] tracking-[0.4em] uppercase text-copper">Texarkana TX</div>

        <div className="divider mx-auto my-7" />

        <h2 id="age-gate-title" className="font-serif text-3xl sm:text-4xl text-sand leading-tight">
          Are you 21 or older?
        </h2>
        <p className="mt-4 text-sm text-sand/75 leading-relaxed">
          You must be 21 years of age or older to enter this site. By entering you confirm you meet
          this requirement and agree to our Terms of Service.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <button
            ref={yesRef}
            data-testid="age-gate-confirm-btn"
            onClick={confirm}
            className="ranch-btn-gold w-full sm:flex-1 px-7 py-3.5 text-sm"
          >
            Yes, I'm 21+
          </button>
          <button
            data-testid="age-gate-decline-btn"
            onClick={decline}
            className="ranch-btn-ghost w-full sm:flex-1 px-7 py-3.5 text-sm"
          >
            No, Exit
          </button>
        </div>

        <p className="mt-7 text-[11px] leading-relaxed text-tan/70">
          These statements have not been evaluated by the Food and Drug Administration. Products are
          not intended to diagnose, treat, cure, or prevent any disease.
        </p>
      </div>
    </div>
  );
}
